import React from 'react';
import style from './sensors.module.scss';
import cn from 'classnames';
import HamHeader from '../Header/HamburgerHeader';
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import Cross from '@assets/images/Fireboard/CrossCircle';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const Addsensor = props => {
  const {
    setPopup,
    selectedStation,
    group,
    codeValue,
    onRegisterSensor,
    namedFieldValue,
    isDuplicate,
  } = props;

  const onclickCancle = () => {
    setPopup({ type: 'Sensor Group' });
  };

  return (
    <div
      className={cn(
        style.RegisterSensor,
        'col-12 h-100 p-3 d-flex flex-column align-items-center'
      )}
    >
      <div className="w-100 mb-3">
        <HamHeader
          label={FLABEL().HEADER_ADDSENSOR}
          onClickback={() => setPopup(null)}
        />
      </div>

      <div
        className={cn(
          style.sensorGrpsContainer,
          'w-65 h-100 fw-500 d-flex flex-column justify-content-center align-items-center'
        )}
      >
        <div className="col-6 px-0 text-center mt-auto">
          <div className="fw-500 pb-3">
            {namedFieldValue
              ? `${FLABEL().NAMED_SENSOR_NAME}: ${namedFieldValue}`
              : `${FLABEL().TABLE_SENSOR_TABLE}: ${selectedStation?.name ||
                  selectedStation?.number || ''}`}
          </div>
          <div>
            {FLABEL().TABLE_SENSOR_SENSOR_GROUP} : {group?.name}
          </div>

          <div
            className={cn(
              style.displayCode,
              'd-flex flex-column justify-content-center align-items-center position-relative'
            )}
          >
            <div
              className={cn(style.CrossIcon)}
              onClick={() => onclickCancle()}
            >
              <Cross />
            </div>
            {codeValue}
          </div>
          <div className={cn(style.errorText)}>
            {isDuplicate ? 'Sensor with this code is already registered.' : ''}
          </div>
          <div className={cn(style.checkmark)}>
            <SuccessIcon />
          </div>
          <div>{FLABEL().TABLE_SENSOR_SENSOR_ADDED}</div>
        </div>

        <div className="w-50 d-flex gap-2 pt-3 mt-auto">
          <div className="col-6 pl-0 pr-2">
            <button
              className={cn(style.Secondarybtn, 'col-12 fw-500')}
              onClick={() => onclickCancle()}
            >
              {FLABEL().TABLE_SENSOR_RESCAN}
            </button>
          </div>
          <div className={cn('col-6 pr-0 pl-2')}>
            <button
              className={cn(style.primaryBtn, 'col-12 fw-500', {
                [style.disabled]: isDuplicate,
              })}
              onClick={() => {
                onRegisterSensor(codeValue);
              }}
            >
              {FLABEL().TABLE_SENSOR_DONE}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addsensor;
